import { createFileRoute } from '@tanstack/react-router'

import { WallDisplayPage } from '@/components/pages/Dashboard/Wall/WallDisplayPage'

export const Route = createFileRoute('/_liff/wall-display')({
  component: WallDisplayPage,
  staticData: {
    authRequired: false,
  },
})
